import React, { useState } from 'react';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
import AddJeCategory from './AddJeCategory';
import EditJeCategory from './EditJeCategory';
import useGetGlJeCategoryList from '../../../../hooks/Finance/useGetGlJeCategoryList';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable';
import { Link } from 'react-router-dom';

  const Index = () => {
    const [ID, setID] = useState<string>('');

    const { t } = useTranslation();

    const { GlJeCategoryList, loading, error } = useGetGlJeCategoryList();

    const columns = [
      { title: t('LocalName'), key: 'Name2' },
      { title: t('GlobalName'), key: 'Name' },

      { title: t(''), key: 'action', className: 'text-end' },
    ];

    const tableData = GlJeCategoryList?.map((item) => {
      let rowClass;

      return {
        Name2: item.name2,
        Name: item.name,

        action: (
          <button
            type="button"
            className="btn btn-sm btn-outline-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalEditDailyRates"
            onClick={() => setID(item.id)}>
            <i className="far fa-lg fa-fw fa-edit me-1"></i>
            {t('Button.Edit')}
          </button>
        ),

        rowClass, // استخدم rowClass هنا
      };
    });

    //____________________________
    var BcrumbList = [
      {
        name: 'Home',
        link: ':moduleHome',
      },
      {
        name: 'JeCategories',
        link: null,
      },
    ];

    return (
      <div>
        <div className="d-flex align-items-center">
          <Breadcrumb BreadcrumbList={BcrumbList} PageName="JeCategories" />

          <div className="ms-auto">
            <Link
              to=""
              className="btn   btn-theme"
              data-bs-toggle="modal"
              data-bs-target="#modalAddDailyRates">
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddJeCategory')}
            </Link>
          </div>
        </div>

        <Card>
          <Loading loading={loading} error={error}>
            <CardBody>
              <NtxTable
                data={tableData || []}
                columns={columns}
                dataPerPage={10}
                theadClass=""
                tableClass="table text-nowrap table-hover "
                enableSearch
                showRecordsSelector
              />
            </CardBody>
          </Loading>
        </Card>

        <ModalComponent title={t("AddJeCategory")} id="modalAddDailyRates" size="sm">
          <AddJeCategory />
        </ModalComponent>

        <ModalComponent title={t("EditJeCategory")} id="modalEditDailyRates" size="sm">
          {ID && <EditJeCategory ID={ID} />}
        </ModalComponent>
      </div>
    );
  };

export default Index;
